export default from './BuyerRegistration';



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/components/BuyerRegistration/index.js